// extracted by mini-css-extract-plugin
export default {"clock":"clock__H4xY3","clockDate":"clockDate__5KW31","clockTime":"clockTime__8HpeY","debugMode":"debugMode__9ieDR"};